import React from "react";
import { Card, CardBody, Col, Row, Table } from "reactstrap";
import { Link } from "react-router-dom";
import { DateTime } from "components/common/Date";
import { StockMovementTypeLabel } from "../constants/stock-movement.constants";
import { useStockMovementOverview } from "./StockMovementOverviewContext";

const OverviewTab = () => {
  const { stockMovement: record } = useStockMovementOverview();
  if (!record) return null;

  const when = record.createdAt ?? record.created_at;
  const creatorName = record.creator
    ? [record.creator.firstName, record.creator.lastName]
        .filter(Boolean)
        .join(" ") || record.creator.email
    : null;

  return (
    <Row>
      <Col>
        <Card>
          <CardBody>
            <div className="text-muted">
              <h6 className="mb-3 text-uppercase">Movement info</h6>
              <div className="table-responsive">
                <Table className="table-borderless mb-0">
                  <tbody>
                    <tr>
                      <th
                        className="ps-0"
                        scope="row"
                        style={{ width: "180px" }}
                      >
                        Type :
                      </th>
                      <td className="text-muted">
                        {record.movementType
                          ? StockMovementTypeLabel[record.movementType]
                          : "—"}
                      </td>
                    </tr>
                    <tr>
                      <th className="ps-0" scope="row">
                        Product :
                      </th>
                      <td className="text-muted">
                        {record.product ? (
                          <Link
                            className="link fw-medium"
                            to={`/inventory-management/products/${record.product.id}`}
                          >
                            {record.product.name}
                          </Link>
                        ) : (
                          `#${record.productId}`
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th className="ps-0" scope="row">
                        Quantity :
                      </th>
                      <td
                        className={
                          record.quantity < 0 ? "text-danger" : "text-success"
                        }
                      >
                        {record.quantity}
                      </td>
                    </tr>
                    <tr>
                      <th className="ps-0" scope="row">
                        From :
                      </th>
                      <td className="text-muted">
                        {record.fromLocation?.name ??
                          (record.fromLocationId != null
                            ? `#${record.fromLocationId}`
                            : "—")}
                      </td>
                    </tr>
                    <tr>
                      <th className="ps-0" scope="row">
                        To :
                      </th>
                      <td className="text-muted">
                        {record.toLocation?.name ??
                          (record.toLocationId != null
                            ? `#${record.toLocationId}`
                            : "—")}
                      </td>
                    </tr>
                    <tr>
                      <th className="ps-0" scope="row">
                        Reference :
                      </th>
                      <td className="text-muted">
                        {record.referenceType || record.referenceId != null
                          ? `${record.referenceType ?? "—"}${record.referenceId != null ? ` #${record.referenceId}` : ""}`
                          : "—"}
                      </td>
                    </tr>
                    <tr>
                      <th className="ps-0" scope="row">
                        Created :
                      </th>
                      <td className="text-muted">
                        {when ? <DateTime date={when} /> : "—"}
                      </td>
                    </tr>
                    <tr>
                      <th className="ps-0" scope="row">
                        Recorded by :
                      </th>
                      <td className="text-muted">
                        {creatorName ??
                          (record.createdBy != null
                            ? `#${record.createdBy}`
                            : "—")}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>

              {when ? (
                <div className="pt-3 border-top border-top-dashed mt-4">
                  <Row className="gy-3">
                    <Col lg={3} sm={6}>
                      <div>
                        <p className="mb-2 text-uppercase fw-medium">Created</p>
                        <h5 className="fs-14 mb-0">
                          <DateTime date={when} />
                        </h5>
                      </div>
                    </Col>
                  </Row>
                </div>
              ) : null}
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default OverviewTab;
